import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle, BarChart3, Brain } from 'lucide-react';
export function ClinicalEvidence() {
  return <section className="py-8 px-3" data-id="element-14">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-15">
        {/* Bloque 1: Criterio clínico */}
        <FadeIn data-id="element-16">
          <div className="bg-surface border border-accent/20 rounded-2xl p-5 md:p-8" data-id="element-17">
            <div className="flex items-center gap-2 mb-3" data-id="element-18">
              <Brain size={22} className="text-accent" data-id="element-19" />
              <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-20">
                Basado en ciencia deportiva real, no en mitos de gimnasio
              </h2>
            </div>

            <p className="text-white/60 mb-4" data-id="element-21">
              Este sistema está construido a partir de:
            </p>

            <ul className="space-y-2.5" data-id="element-22">
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-23">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-24" />
                <span data-id="element-25">
                  Protocolos utilizados con atletas y pacientes reales
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-26">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-27" />
                <span data-id="element-28">
                  Enfoque basado en evidencia científica actualizada (ISSN,
                  ACSM, AIS)
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-29">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-30" />
                <span data-id="element-31">
                  Integración de periodización + suplementación + recuperación
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-32">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-33" />
                <span data-id="element-34">
                  Aplicación práctica pensada para el tiempo real de consulta
                </span>
              </li>
            </ul>

            <div className="mt-5 pt-4 border-t border-white/10 space-y-1.5" data-id="element-35">
              <p className="text-white/50 text-sm italic" data-id="element-36">
                No es teoría. No es contenido académico sin aplicación.
              </p>
              <p className="text-accent font-bold text-sm md:text-base" data-id="element-37">
                Es un sistema pensado para potenciar el rendimiento y la
                composición corporal.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Bloque 2: Qué cambia */}
        <FadeIn delay={0.15} data-id="element-38">
          <div className="bg-surface border border-accent/20 rounded-2xl p-5 md:p-8" data-id="element-39">
            <div className="flex items-center gap-2 mb-3" data-id="element-40">
              <BarChart3 size={22} className="text-accent" data-id="element-41" />
              <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-42">
                ¿Qué cambia cuando aplicás este sistema?
              </h2>
            </div>

            <ul className="space-y-2.5" data-id="element-43">
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-44">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-45" />
                <span data-id="element-46">Reducís el tiempo de armado de cada plan deportivo</span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-47">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-48" />
                <span data-id="element-49">Mejorás la adherencia y los resultados del paciente</span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-50">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-51" />
                <span data-id="element-52">
                  Tenés un criterio claro para pautar suplementación segura
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-white/80 text-sm md:text-base" data-id="element-53">
                <CheckCircle size={18} className="text-accent shrink-0 mt-0.5" data-id="element-54" />
                <span data-id="element-55">
                  Podés justificar honorarios más altos con respaldo profesional
                </span>
              </li>
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}